// eslint-disable-next-line
export default {
    background: { 
      primary: "#e5e5e5",
      paper: "#f9f9f9"
  },
    divider: "#727272",
    grey: { primary: "#c2c2c2" },
    primary: { main: "#780000" },
    red: { primary: "#780000" },
    secondary: { main: "#4d4643" },
    status: {
      green: "#2cc990",
      red: "#f24e4e",
      yellow: "#f24e4e",
    },
    text: {
      primary: "#2b2320",
      secondary: "#4d4643",
    },
  };
  